import { Grid2, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";
import {
	AvailabilityViewModel,
	TimeCommitmentViewModel
} from "../../../../../ViewModels/FreelancerOnboardingMyAvailabilityStepViewModel";
import TimeCommitmentButton from "./TimeCommitmentButton";

interface MissionTimeCommitmentSelectorProps {
	readonly selectedTimeCommitment: TimeCommitmentViewModel | null;
	readonly selectedAvailability: AvailabilityViewModel | null;
	readonly onTimeCommitmentSelect: (timeCommitment: TimeCommitmentViewModel) => void;
	readonly touched: boolean;
	readonly error: string | undefined;
}

export default function MissionTimeCommitmentSelector({
	selectedTimeCommitment,
	selectedAvailability,
	onTimeCommitmentSelect,
	touched,
	error
}: MissionTimeCommitmentSelectorProps) {
	const { t } = useTranslation();

	return (
		<>
			{/* Mission Time Commitment - Only show when mission end date is selected */}
			<Grid2 size={{ xs: 12 }}>
				<Typography variant="body1" sx={{ color: zoullooColors.grey[700] }}>
					{t("freelancerOnboardingMyAvailability.missionTimeCommitment")}
				</Typography>
			</Grid2>
			{/* Mission Full Time Button */}
			<TimeCommitmentButton
				type="fullTime"
				isSelected={selectedTimeCommitment === "fullTime"}
				onClick={() => onTimeCommitmentSelect("fullTime")}
			/>

			{/* Mission Part Time Button */}
			<TimeCommitmentButton
				type="partTime"
				isSelected={selectedTimeCommitment === "partTime"}
				onClick={() => onTimeCommitmentSelect("partTime")}
			/>

			{selectedAvailability === "onMission" &&
				touched &&
				error &&
				!selectedTimeCommitment && (
					<Grid2 size={{ xs: 12 }}>
						<Typography color="error" variant="body1">
							{error}
						</Typography>
					</Grid2>
				)}
		</>
	);
}
